import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';

function SetupForm({ handleClose, handleData }) {

  const [data, setData] = useState({
    businessName: '',
    phoneNumber: '',
    state: '',
    status: 'no_subscription'
  });
  const [inputError, setInputError] = useState(null);

  function handleChange(event) {
    event.preventDefault();
    const { id, value } = event.target;
    setInputError(prevData => ({ ...prevData, [id]: '' }));
    setData(prevData => ({ ...prevData, [id]: value }));
  }

  const resetData = () => {
    setData({
      businessName: '',
      phoneNumber: '',
      state: '',
      status: 'no_subscription'
    });
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const { businessName, phoneNumber, state } = data;
    if (!businessName) {
      setInputError({ ...inputError, businessName: 'This field is required.' });
    } else if (!phoneNumber) {
      setInputError({ ...inputError, phoneNumber: 'This field is required.' });
    } else if (!state) {
      setInputError({ ...inputError, state: 'This field is required.' });
    } else {
      handleData(data);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className='row mb-3'>
        <div className='col-md-6'>
          <Form.Group className='mb-3' controlId='businessName'>
            <Form.Label>Business Name</Form.Label>
            <Form.Control
              placeholder='Name of the individual, firm or company'
              onChange={handleChange}
              value={data.businessName}
              className={inputError && inputError.businessName ? 'border-danger' : ''}
              isInvalid={inputError && inputError.businessName}
            />
            <Form.Control.Feedback type="invalid">{inputError && inputError.businessName}</Form.Control.Feedback>
          </Form.Group>
        </div>
        <div className='col-md-6'>
          <Form.Group className='mb-3' controlId='phoneNumber'>
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              placeholder='Enter the business phone number'
              onChange={handleChange}
              value={data.phoneNumber}
              className={inputError && inputError.phoneNumber ? 'border-danger' : ''}
              isInvalid={inputError && inputError.phoneNumber}
            />
            <Form.Control.Feedback type="invalid">{inputError && inputError.phoneNumber}</Form.Control.Feedback>
          </Form.Group>
        </div>
        <div className='col-md-6'>
          <Form.Group className='mb-3' controlId='state'>
            <Form.Label>State</Form.Label>
            <Form.Control
              placeholder='Select state'
              onChange={handleChange}
              value={data.state}
              className={inputError && inputError.state ? 'border-danger' : ''}
              isInvalid={inputError && inputError.state}
            />
            <Form.Control.Feedback type="invalid">{inputError && inputError.state}</Form.Control.Feedback>
          </Form.Group>
        </div>
      </div>
      <div className='d-flex align-items-center justify-content-between pt-3'>
        <Button
          variant="outline-danger"
          className='px-5 py-2'
          onClick={handleClose}
        >
          Close
        </Button>
        <Button
          variant="primary"
          className='px-5 py-2'
          type='submit'
        >
          Save
        </Button>
      </div>
    </Form >
  );
}

export default SetupForm;
